import React, { useState } from 'react';
import { useControleDemanda } from '../context/ControleDemandaProvider';
import { useAuth } from '../../shared/context/AuthContext';

export default function ModalDevolver({ analise, onClose, onSuccess }) {
  const { devolverAnalise } = useControleDemanda();
  const { user } = useAuth();
  const [descricaoRetorno, setDescricaoRetorno] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!descricaoRetorno.trim()) {
      alert('Por favor, informe o motivo da devolução.');
      return;
    }

    setLoading(true);
    try {
      await devolverAnalise(analise.analisedemanda_id, descricaoRetorno.trim(), user.id);
      onSuccess();
    } catch (error) {
      console.error('Erro ao devolver análise:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-devolver">
        <div className="modal-header">
          <h3>Devolver Análise</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="analise-info">
            <h4>Análise - Demanda #{analise.demanda_id}</h4>
            <p><strong>Funcionário:</strong> {analise.analisedemanda_funcionario_envolvido_nome}</p>
            <p><strong>Setor:</strong> {analise.analisedemanda_setor_descricao}</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="descricaoRetorno">Motivo da Devolução *</label>
              <textarea
                id="descricaoRetorno"
                value={descricaoRetorno}
                onChange={(e) => setDescricaoRetorno(e.target.value)}
                className="form-control"
                rows="6"
                placeholder="Descreva o motivo da devolução e as correções necessárias..."
                required
              />
              <small className="form-text">
                Esta informação será registrada no histórico da análise.
              </small>
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-warning"
                disabled={loading || !descricaoRetorno.trim()}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Devolvendo...
                  </>
                ) : (
                  <>
                    <i className="fas fa-undo"></i>
                    Devolver
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}